// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"c9a9f689","231":"37b2bcc8","453":"26905a25","612":"988aefb5","676":"6fd62b48","702":"5ef69b08","773":"643987f9","869":"e5ebf081","881":"2974c5b4"}[chunkId] + ".chunk.js";
};